const map = {
	"./bug/image_2026-07-22_23-22-31.png": 5761,
	"./bug/image_2026-07-22_23-22-32-1.png": 7672,
	"./bug/image_2026-07-22_23-22-32.png": 5594,
	"./bug/image_2026-07-22_23-48-23.png": 9652,
	"./bug/image_2026-07-22_23-50-00.png": 200,
	"./cherry-garden/photo_2026-02-16_22-01-56.jpg": 3870,
	"./collector/photo_2026-06-02_09-38-04 (2).jpg": 7834,
	"./collector/photo_2026-06-02_09-38-04 (3).jpg": 4357,
	"./collector/photo_2026-06-02_09-38-04.jpg": 5529,
	"./idiot/photo_2025-09-02_11-16-27 (2).jpg": 5674,
	"./idiot/photo_2025-09-02_11-16-27.jpg": 7049,
	"./master-margarita/photo_2026-01-12_21-54-27 (2).jpg": 671,
	"./master-margarita/photo_2026-01-12_21-54-27.jpg": 7928,
	"./methods/photo_2025-11-17_22-47-01.jpg": 9283,
	"./methods/photo_2025-11-17_22-47-56.jpg": 9519,
	"./methods/photo_2025-11-17_22-49-07.jpg": 7095,
	"./picnic/photo_2026-04-28_09-53-56.jpg": 4446,
	"./pride/photo_2026-03-24_10-29-08 (2).jpg": 3696,
	"./pride/photo_2026-03-24_10-29-08.jpg": 3419
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9211;